import { KPIsService } from "@/_services";
export const kpi = {
  namespaced: true,
  state: {
    entity: {
      data: [],
      status: {},
    },
    excel: {
      data: [],
      status: {},
    },
  },
  mutations: {
    getRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getError(state, error) {
      state.entity.data = null;
      state.entity.status = {
        error,
      };
    },
    getSuccess(state, response) {
      state.entity.data = response;
      state.entity.status = {
        loaded: true,
      };
    },
    excelRequest(state) {
      state.excel.status = {
        downloading: true,
      };
    },
    excelError(state, error) {
      state.excel.data = null;
      state.excel.status = {
        error,
      };
    },
    excelSuccess(state, response) {
      state.excel.data = response;
      state.excel.status = {
        downloaded: true,
      };
    },
  },
  actions: {
    get({ commit }, filters) {
      commit("getRequest");
      KPIsService.get(filters)
        .then((res) => {
          commit("getSuccess", res);
        })
        .catch((error) => {
          commit("getError", error);
        });
    },
    excel({ commit }, filters) {
      commit("excelRequest");
      KPIsService.excel(filters)
        .then((res) => {
          commit("excelSuccess", res);
        })
        .catch((error) => {
          commit("excelError", error);
        });
    },
  },
};
